<template>
    <div class="map">
        <GmapMap
                :options="opts"
                :center="{lat: lat,
						lng: lng}"
                :zoom="14"
                style="width:100%;height:100%"
        >
            <gmap-custom-marker
                    :marker="{ lat: lat, lng: lng }"
                    alignment="center"
            >
                <img src="/hive-pin.png" />
            </gmap-custom-marker>
        </GmapMap>
    </div>
</template>

<script>
	import Vue from 'vue'
	import * as VueGoogleMaps from 'vue2-google-maps'
	import GmapCustomMarker from 'vue2-gmap-custom-marker';

	Vue.use(VueGoogleMaps, {
		load: {
			key: 'AIzaSyDst9H0uJk_GNO5B40B3BnB5Fv3ai72y5w',
			libraries: 'places', // This is required if you use the Autocomplete plugin
			// OR: libraries: 'places,drawing'
			// OR: libraries: 'places,drawing,visualization'
			// (as you require)

			//// If you want to set the version, you can do so:
			// v: '3.26',
		},

		//// If you intend to programmatically custom event listener code
		//// (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
		//// instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
		//// you might need to turn this on.
		// autobindAllEvents: false,

		//// If you want to manually install components, e.g.
		//// import {GmapMarker} from 'vue2-google-maps/src/components/marker'
		//// Vue.component('GmapMarker', GmapMarker)
		//// then disable the following:
		// installComponents: true,
	});
	export default {
		name: "GoogleMaps",
		components: {
			'gmap-custom-marker': GmapCustomMarker
		},
		props: {
			marker: String
		},
		data() {
			return {
				lat: -37.822673,
				lng: 145.070895,
				opts: {
					styles: [{
						"featureType": "administrative",
						"elementType": "all",
						"stylers": [{"visibility": "off"}]
					}, {
						"featureType": "administrative",
						"elementType": "labels.text.fill",
						"stylers": [{"color": "#444444"}]
					}, {
						"featureType": "landscape",
						"elementType": "all",
						"stylers": [{"color": "#f2f2f2"}]
					}, {
						"featureType": "poi",
						"elementType": "geometry.fill",
						"stylers": [{"saturation": "-100"}, {"lightness": "57"}]
					}, {
						"featureType": "poi",
						"elementType": "geometry.stroke",
						"stylers": [{"lightness": "1"}]
					}, {
						"featureType": "poi",
						"elementType": "labels",
						"stylers": [{"visibility": "off"}]
					}, {
						"featureType": "road",
						"elementType": "all",
						"stylers": [{"saturation": -100}, {"lightness": 45}]
					}, {
						"featureType": "road.highway",
						"elementType": "all",
						"stylers": [{"visibility": "simplified"}]
					}, {
						"featureType": "road.arterial",
						"elementType": "labels.icon",
						"stylers": [{"visibility": "off"}]
					}, {
						"featureType": "transit",
						"elementType": "all",
						"stylers": [{"visibility": "off"}]
					}, {
						"featureType": "transit",
						"elementType": "geometry",
						"stylers": [{"visibility": "on"}]
					}, {
						"featureType": "transit",
						"elementType": "labels",
						"stylers": [{"visibility": "off"}]
					}, {
						"featureType": "transit",
						"elementType": "labels.text",
						"stylers": [{"visibility": "off"}]
					}, {
						"featureType": "transit",
						"elementType": "labels.text.fill",
						"stylers": [{"visibility": "off"}, {"color": "#484848"}]
					}, {
						"featureType": "transit",
						"elementType": "labels.text.stroke",
						"stylers": [{"visibility": "off"}]
					}, {
						"featureType": "transit",
						"elementType": "labels.icon",
						"stylers": [{"visibility": "on"}]
					}, {
						"featureType": "transit.station.bus",
						"elementType": "all",
						"stylers": [{"visibility": "on"}]
					}, {
						"featureType": "transit.station.bus",
						"elementType": "labels.text.fill",
						"stylers": [{"saturation": "0"}, {"lightness": "0"}, {"gamma": "1.00"}, {"weight": "1"}]
					}, {
						"featureType": "transit.station.bus",
						"elementType": "labels.icon",
						"stylers": [{"saturation": "-100"}, {"weight": "1"}, {"lightness": "0"}]
					}, {
						"featureType": "transit.station.rail",
						"elementType": "all",
						"stylers": [{"visibility": "on"}]
					}, {
						"featureType": "transit.station.rail",
						"elementType": "labels.text.fill",
						"stylers": [{"gamma": "1"}, {"lightness": "40"}]
					}, {
						"featureType": "transit.station.rail",
						"elementType": "labels.icon",
						"stylers": [{"saturation": "-100"}, {"lightness": "30"}]
					}, {
						"featureType": "water",
						"elementType": "all",
						"stylers": [{"color": "#d2d2d2"}, {"visibility": "on"}]
					}],
					maxZoom: 20,
					minZoom: 0,
					mapTypeId: 'roadmap',
					zoomControl: true,
					mapTypeControl: false,
					scaleControl: false,
					streetViewControl: false,
					rotateControl: false,
					fullscreenControl: true,
					disableDefaultUi: false
				}
			}
		},
		mounted: function () {
			// let
			//
			//
			// opts.clickableIcons = true;
			// opts.disableDoubleClickZoom = false;
			// opts.draggable = true;
			// opts.keyboardShortcuts = true;
			// opts.scrollwheel = true;
			// const map = new google.maps.Map(this.$el, opts);
		}
	}
</script>

<style scoped>
    .map {
        width: 100%;
        height: 100%;
    }
</style>